import { createClient } from '@supabase/supabase-js';

// Supabase接続情報は環境変数から読む（projects/frontend/.env、Vercelでは環境変数設定）。
// anonキーはビルドに埋め込まれ参加者から見える前提の公開鍵なので、
// サーバ側は必ず RLS で INSERT のみ許可にしておくこと（supabase/schema.sql 参照）。
// service_role キーは絶対にフロントに書かない。
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// 環境変数が未設定の環境（ローカル開発など）では null になり、
// ログ送信は experimentLog.js 側で無効化される（アプリ本体は通常動作する）。
export const supabase =
  supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;
